import { Icon } from './Icon';
import type { NavigationItem } from './types';
import type { PageKey } from './AppShell';

interface MobileNavProps {
  navigationItems: NavigationItem[];
  currentPage: PageKey;
  onNavigate: (page: PageKey) => void;
}

export function MobileNav({ navigationItems, currentPage, onNavigate }: MobileNavProps) {
  // Filter to show only main navigation items in mobile bottom nav
  // Exclude settings (accessible via header) and show max 5 items
  const mobileNavItems = navigationItems
    .filter((item) => item.key !== 'settings')
    .slice(0, 5);

  return (
    <nav data-testid="nav-mobile" className="lg:hidden fixed bottom-0 left-0 right-0 z-20 bg-white border-t border-gray-200 safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {mobileNavItems.map((item) => {
          const isActive = currentPage === item.key;

          return (
            <button
              key={item.key}
              onClick={() => onNavigate(item.key)}
              data-testid={`nav-mobile-link-${item.key}`}
              className={`flex flex-col items-center justify-center flex-1 h-full px-1 py-2 transition-colors ${
                isActive ? 'text-gray-900' : 'text-gray-500'
              }`}
              aria-current={isActive ? 'page' : undefined}
            >
              {isActive && (
                <div className="absolute top-1 w-4 h-1 bg-gray-900 rounded-full" />
              )}
              <div className="relative">
                <Icon
                  name={item.icon}
                  size={20}
                  className={isActive ? 'text-gray-900' : 'text-gray-500'}
                />
                {item.badge !== undefined && item.badge > 0 && (
                  <span className="absolute -top-1 -right-1 w-4 h-4 bg-primary-600 text-white text-[10px] font-bold rounded-full flex items-center justify-center">
                    {item.badge > 9 ? '9+' : item.badge}
                  </span>
                )}
              </div>
              <span
                className={`mt-1 text-[11px] font-medium truncate max-w-full ${
                  isActive ? 'text-gray-900' : 'text-gray-500'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
